import React, { useEffect, useState } from "react";
import style from "./dashboard.module.scss";
import toPersianNumber from "../../helpers/actions/toPersianNumber"
import BarChart from "./charts/barChart"
import LineChart from "./charts/lineChart"
import PieChart from "./charts/pieChart"
import { GetDashboard, GetDashboardHeader, GetDashboardOrder, GetDashboardVariantDetails, SubmitAddChannel } from "../../actions/APIcalls"
import toEnglishNumber from "../../helpers/actions/toEnglishNumber";
import moment from "moment-jalaali"
import Button from "../Button/button"
import { withRouter, Link } from "react-router-dom"
import ExpiredAccountWarning from "../expiredAccountWarning/expiredAccountWarning";
import GradientToast from "../gradientToast/Toast"
import numberWithCommas from "../../helpers/actions/numberWithCommas";
import disconnectTextGenerator from '../../helpers/actions/disconnectedText'
import DownGradeWarning from "../downGradeWarning/downGradeWarning";
import Skeleton from "./skeleton"
import HeaderSkeleton from "./headerSkeleton"
import OrderSkeleton from "./orderSkeleton"
import VariantDetailsSkeleton from "./variantDetailSkeleton"
import noChannelEmptyState from '../../assets/icons/EmptyStates/dashboard_nochannel.svg'
import EditChannelModal from "../editChannelModal/editChannelModal"
import GeneralWarning from "../generalWarning/warning"
import ProgressBar from './progressBar/progressbar'


// const Months = ['فروردین','اردیبهشت','خرداد','تیر','مرداد','شهریور','مهر','آبان','آذر','دی','بهمن','اسفند',]

const array = [{ name: "تعداد تنوع‌های فعال", count: "2054", percentage: "80%" }, {
    name: "تعداد تنوع‌های فعال",
    count: "2054",
    percentage: "80%"
}, { name: "تعداد تنوع‌های فعال", count: "2054", percentage: "80%" }, {
    name: "تعداد تنوع‌های فعال",
    count: "2054",
    percentage: "80%"
}, { name: "تعداد تنوع‌های فعال", count: "2054", percentage: "80%" }, {
    name: "تعداد تنوع‌های فعال",
    count: "2054",
    percentage: "80%"
}]
const cards = [
    {
        name: "تعداد تنوع‌های فعال", tag: "activeVariantCount", icon: "R", iconClass: 'activeVariants', details: '۶۸٪ کل تنوع‌ها'
    },
    {
        name: "تعداد قیمت‌گذاری", tag: "changePriceCount", icon: "S", iconClass: 'pricingNumber', details: 'تاکنون'
    },
    {
        name: "موجودی کیف پول", tag: "walletAmount", icon: "T", iconClass: 'walletBallance', details: '۴,۵۰۰,۶۷۰ مرتبه قیمت‌گذاری'
    },
    {
        name: "روزهای باقیمانده", tag: "remainDay", icon: "U", iconClass: 'remainDay', details: 'با توجه به تنظیمات فعلی'
    }
]
const titleCarousel = ["پرفروش‌ترین تنوع‌ها", "کم فروش‌ترین تنوع‌ها", "پرسودترین تنوع‌ها", "کم ‌سودترین تنوع‌ها", "بدون قابلیت فعال‌سازی مجدد", "تنوع‌های غیرفعال شده‌ی امروز", "با حاشیه سود کمتر از ۱۰ درصد", "تنوع‌های با رقابت شدید", "تنوع‌های با مرجوعی بالا"]
const dailyRef = React.createRef();
const weeklyRef = React.createRef();
const monthlyRef = React.createRef();
const stockRef = React.createRef();
const varaityStatusRef = React.createRef();
const varaityInfoRef = React.createRef();
const varaityCompetetionRef = React.createRef();
const lastThrityDaysRef = React.createRef();

const Dashboard = (props) => {
    const [editModal, setEditModal] = useState({
        show: false
    })
    const [hasSkeleton, setHasSkeleton] = useState({
        headerSkeleton: false,
        orderSkeleton: false,
        variantDetailSekeleton: false,
    })
    const [reportType, setReportType] = useState("weekly")
    const [hasChannel, setHasChannel] = useState(false)
    const [data, setData] = useState({
        header1: {
            productCount: 0,
            variantCount: 0,
            changePriceCount: 0,
            remainDay: 0,
            pannelType: 0
        },
        inventoryManagement: {
            active: { available: 0, unavailable: 0 },
            deactivate: { available: 0, unavailable: 0 },
            runningOut: 0,
            returning: 0,
            inStock: 0,
        },
        compete: { haveCompete: 0, noCompete: 0 },
        boxPosition: { inBox: 0, outOfBox: 0 },
        completeStatus: { complete: 0, inComplete: 0 },
        salesReport: []
    })
    useEffect(async () => {
        await createDashboard()
    }, [])

    const createDashboard = async () => {
        let tmp = hasSkeleton
        tmp.headerSkeleton = true
        tmp.orderSkeleton = true
        tmp.variantDetailSekeleton = true
        setHasSkeleton({ ...tmp })
        await getDashboardHeader()
        await getDashboardOrder()
        await getDashboardVariantDetails()
    }

    const getDashboardHeader = async () => {
        let res = await GetDashboardHeader()
        if (typeof res !== "undefined") {
            let temp = data
            temp.header1 = res.data.header1
            if (res.data.hasChannel) {
                setHasChannel(true)
            }
            setData({ ...temp })
        }
        let skeleton = hasSkeleton
        skeleton.headerSkeleton = false
        setHasSkeleton({ ...skeleton })
    }

    const getDashboardOrder = async () => {
        let res = await GetDashboardOrder()
        if (typeof res !== "undefined") {
            let temp = data
            temp.salesReport = res.data.salesReport
            setData({ ...temp })
        }
        let skeleton = hasSkeleton
        skeleton.orderSkeleton = false
        setHasSkeleton({ ...skeleton })
    }

    const getDashboardVariantDetails = async () => {
        let res = await GetDashboardVariantDetails()
        if (typeof res !== "undefined") {
            let temp = data
            temp.completeStatus = res.data.completeStatus
            temp.compete = res.data.compete
            temp.boxPosition = res.data.boxPosition
            setData({ ...temp })
        }
        let skeleton = hasSkeleton
        skeleton.variantDetailSekeleton = false
        setHasSkeleton({ ...skeleton })
    }

    const cardRenderer = (item, index) => {
        let details = ''

        if (item.tag == 'activeVariantCount' && data.header1.activeVariantPercent) {
            details = `${toPersianNumber(numberWithCommas(data.header1.activeVariantPercent))}٪ کل تنوع‌ها`
        }
        if (item.tag == 'walletAmount' && data.header1.walletPricingCount) {
            details = `${data.header1.walletPricingCount > 0 ? toPersianNumber(numberWithCommas(data.header1.walletPricingCount)) : '۰'} مرتبه قیمت‌گذاری`
        }
        if (item.tag == 'remainDay') {
            details = 'با توجه به تنظیمات فعلی'
        }
        if (item.tag == 'changePriceCount') {
            details = 'تاکنون'
        }
        return (
            <div className={style.card} key={index}>
                <div className={style.icon}><div className={style[item.iconClass]}></div></div>
                <div className={style.detailsWrapper}>
                    <p className={style.name}>{item.tag === "remainDay" && data.header1[item.tag].type == 'hour' ? 'ساعات باقی‌مانده' : item.name}</p>
                    <p className={style.value}>{item.tag === "remainDay" ? toPersianNumber(numberWithCommas(parseInt(data.header1[item.tag].remain))) : item.tag == 'walletAmount' ? (parseInt(data.header1[item.tag]) > 0 ? toPersianNumber(numberWithCommas(parseInt(data.header1[item.tag]))) + ' تومان ' : '۰ تومان') : toPersianNumber(numberWithCommas(parseInt(data.header1[item.tag])))}</p>
                    {details && <p className={style.details}>({details})</p>}
                </div>
            </div>
        )
    }
    const pieChartRender = (header, tag, ref, chartTag1, chartTag2) => {
        return <div className={style.pieWrapper}>
            <h2>{header} </h2>
            <hr />
            <div className={style.container}>
                <PieChart refrence={ref} tag={tag} data={data[tag]} labels={[chartTag1, chartTag2]} />
            </div>
            <div className={style.content}>
                <div className={style.chartTag}>
                    <div className={style.colorOne}></div>
                    <p>{chartTag1}</p>
                </div>
                <div className={style.chartTag}>
                    <div className={style.colorTwo}></div>
                    <p>{chartTag2}</p>
                </div>
            </div>
        </div>
    }

    const calculateLabels = type => {
        let resultArray = []
        if (type == 'weekDays') {
            for (let i = 6; i >= 0; i--) {
                let newDate = new Date(new Date().setDate(new Date().getDate() - i)).toLocaleDateString('fa-IR', { weekday: 'long', formatMatcher: 'basic' });
                resultArray.push(newDate)
            }
        }
        if (type == 'monthDays') {
            for (let i = 29; i >= 0; i--) {
                let newDate = new Date(new Date().setDate(new Date().getDate() - i)).toLocaleDateString('fa-IR', { day: '2-digit', formatMatcher: 'basic' });
                resultArray.push(newDate)
            }
        }

        return resultArray
    }

    const addChannel = async (email, password) => {
        let params = { username: toEnglishNumber(email), password: toEnglishNumber(password) };
        let res = await SubmitAddChannel(params)
        setEditModal({ ...editModal, show: false })
        await createDashboard()

        return res;
    }

    return <div className={style.container}>
        <EditChannelModal
            show={editModal.show}
            closemodal={() => setEditModal({ ...editModal, show: false })}
            email=''
            editchannel={addChannel}
        />
        <div className={style.wrapper}>
            {
                props.user.expiredAccount &&
                <div className={style.gradientWrapper}>
                    <GradientToast tag="test" value={true}>
                        <>
                            <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                            <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                            <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                        </>
                    </GradientToast>
                </div>
            }

            {
                props.user.disconnected.status &&
                <div className={style.gradientWrapper}>
                    <GradientToast tag="test" value={true}>
                        <>
                            <p className={style.expiredTitle}>{disconnectTextGenerator(props.user.disconnected.channelName)}</p>
                            <p className={style.expiredText}>جهت اتصال دوباره موبیشا به پنل، لطفا اطلاعات خود را در صفحه پنل دیجی‌کالا به‌روز رسانی کنید</p>
                            <Link className={style.expiredLink} to={'/channels'}>ورود به صفحه‌ی  پنل دیجی‌کالا  </Link>
                        </>
                    </GradientToast>
                </div>
            }
            {/*<div className={style.gradientWrapper}>
                <GradientToast tag="test" value={true}>
                    <GeneralWarning />
                </GradientToast>
            </div>*/}



            {hasSkeleton.headerSkeleton ? <HeaderSkeleton />
                :
                <>
                    <h1>
                        داشبورد
                    </h1>
                    <div className={style.welcome}>به ربات موبیشا خوش آمدید.</div>

                    {typeof props.user.progressBar != 'undefined' && (typeof props.user.progressBar.GetReward != 'undefined' && !props.user.progressBar.GetReward) &&
                        <ProgressBar />
                    }

                    <div className={style.cardWrapper}>
                        {
                            cards.map((item, index) => {
                                return cardRenderer(item, index)
                            })
                        }
                    </div>
                </>
            }

            {hasSkeleton.orderSkeleton ? <OrderSkeleton />
                :
                <>
                    {hasChannel && data.header1.activeVariantCount > 0 && <div className={style.row}>
                        {/* {(!data.salesReport.daily_chart.every(item => item === 0) || !data.salesReport.weekly_chart.every(item => item === 0)) && */}
                        {<div className={style.bigCard}>
                            <h2>نمودار فروش روزانه</h2>
                            <hr />
                            <div className={style.canvasWrapper}>
                                <LineChart refrence={dailyRef} tag="daily" labels={['24:00', '6:00', '12:00', '18:00', '23:00']}
                                    data={data.salesReport.daily_chart} />
                            </div>
                            <div className={style.totalCost}>
                                مبلغ کل فروش:
                                <p>{toPersianNumber(numberWithCommas(data.salesReport.daily_total_sales)) + " ریال "}</p>
                            </div>
                        </div>}
                        {/* {((!data.salesReport.daily_chart.every(item => item === 0)) || (!data.salesReport.weekly_chart.every(item => item === 0) && !data.salesReport.monthly_chart.every(item => item === 0))) && */}
                        {<div className={style.bigCard}>
                            <div className={style.selectiveTitles}>
                                <div className={reportType === "weekly" ? style.selectiveButtonSelected : style.selectiveButton}
                                    onClick={() => {
                                        setReportType("weekly")
                                    }}>گزارش فروش هفتگی <div
                                        className={reportType === "weekly" ? style.selectMark : style.unselected}></div></div>
                                <div
                                    className={reportType === "monthly" ? style.selectiveButtonSelected : style.selectiveButton}
                                    onClick={() => {
                                        setReportType("monthly")
                                    }}>گزارش فروش ماهانه <div
                                        className={reportType === "monthly" ? style.selectMark : style.unselected}></div></div>
                            </div>

                            {
                                reportType && reportType === "weekly" &&
                                <div className={style.canvasWrapper}>
                                    <LineChart refrence={weeklyRef} tag="weekly"
                                        labels={calculateLabels('weekDays')}
                                        data={data.salesReport.weekly_chart} />
                                </div>
                            }
                            {
                                reportType && reportType === "monthly" &&
                                <div className={style.canvasWrapper}>
                                    <LineChart refrence={monthlyRef} tag="monthly"
                                        labels={calculateLabels('monthDays')}
                                        data={data.salesReport.monthly_chart} />
                                </div>
                            }
                            <div className={style.totalCost}>
                                مبلغ کل فروش:
                                <p>{(reportType === "weekly" ? toPersianNumber(numberWithCommas(data.salesReport.weekly_total_sales)) + "  ریال  " : reportType === "monthly" && toPersianNumber(numberWithCommas(data.salesReport.monthly_total_sales)) + " ریال ")}</p>
                            </div>
                        </div>}
                    </div>}
                </>
            }


            {hasSkeleton.variantDetailSekeleton ? <VariantDetailsSkeleton /> :
                <>
                    {hasChannel ?
                        (data.header1.activeVariantCount > 0 ?
                            <div className={style.secondrow}>
                                <div className={style.secondbigCardTransparent}>
                                    <div className={style.secondpieRow}>
                                        {pieChartRender("اطلاعات تنوع‌ها", "completeStatus", varaityInfoRef, "تنوع‌های تکمیل اطلاعات شده", "تنوع‌های تکمیل اطلاعات نشده")}
                                        {pieChartRender("موقعیت تنوع‌ها ", "boxPosition", varaityStatusRef, "تنوع‌های در باکس فروش", "تنوع‌های بدون باکس فروش")}
                                        {pieChartRender("رقابت تنوع‌ها", "compete", varaityCompetetionRef, "تنوع‌های دارای رقیب", "تنوع‌های بدون رقیب")}
                                    </div>
                                    {/* <div className={style.pieRow}> */}
                                    {/* {pieChartRender("فروش ۳۰ روز گذشته","lastThrityDays" ,lastThrityDaysRef,"فروش ‌رفته در ۳۰ روز گذشته","فروش نرفته در ۳۰ روز گذشته")} */}
                                    {/* </div> */}
                                </div>
                                {/* <div className={style.bigCard}>
                                <h2>مدیریت موجودی </h2>
                                <hr />
                                <div className={style.canvasWrapper}>
                                    <BarChart refrence={stockRef} tag="stock"
                                        labels={["فروش نرفته در انبار", "انبار مرجوعی", "درحال اتمام", "فعال", "غیرفعال"].reverse()}
                                        data={{ ...data.inventoryManagement }} />
                                </div>
                                <div className={style.row}>
                                    <div className={style.chartTag}>
                                        <div className={style.colorOne}></div>
                                        <p>تنوع‌های دارای موجودی</p>
                                    </div>
                                    <div className={style.chartTag}>
                                        <div className={style.colorTwo}></div>
                                        <p>تنوع‌های بدون موجودی</p>
                                    </div>
                                </div>
                                <div className={style.rowBar}>
                                    <div className={style.totalCostBar}>
                                        کل تنوع‌های فعال:
                                        <p>{toPersianNumber(data.inventoryManagement.active.available + data.inventoryManagement.active.unavailable)}</p>
                                    </div>
                                    <div className={style.totalCostBar}>
                                        کل تنوع‌های غیرفعال:
                                        <p>{toPersianNumber(data.inventoryManagement.deactivate.available + data.inventoryManagement.deactivate.unavailable)}</p>
                                    </div>
                                </div>
                              </div> */}
                            </div> :
                            <div className={style.noChannel}>
                                <div className={style.image}>
                                    <img src={noChannelEmptyState} />
                                </div>
                                <div className={style.text}>تو این صفحه، می‌تونید نمودارهای مربوط به فروش و وضعیت تنوع‌هاتون رو ببینید</div>
                                <div className={style.boldText}>لطفا اطلاعات هر تنوع (قیمت خرید و حداقل حاشیه سود) رو از صفحه تنوع‌ها تکمیل کنید</div>
                                <div className={style.buttonWrapper}>
                                    <Button type="solid" label="ورود به صفحه‌ی تنوع‌ها"
                                        onclick={() => props.history.push("/variants")} /></div>
                            </div>
                        ) :
                        <div className={style.noChannel}>
                            <div className={style.image}>
                                <img src={noChannelEmptyState} />
                            </div>
                            <div className={style.text}>تو این صفحه، می‌تونید نمودارهای مربوط به فروش و وضعیت تنوع‌هاتون رو ببینید</div>
                            <div className={style.boldText}>برای شروع پنل دیجی‌کالا رو ثبت کنید</div>
                            <div className={style.buttonWrapper}>
                                <Button type="solid" label="ثبت پنل جدید" onclick={
                                    // () => setEditModal({ ...editModal, show: true })
                                    () => props.history.push("/channels")
                                } />
                                <Button type="noBorder" label="ورود به صفحه‌ی پنل دیجی‌کالا" onclick={() => props.history.push("/channels")} />
                            </div>
                        </div>
                    }

                </>
            }
        </div>
        <div className={style.footer}>
            <p className={style.lastUpdate}>
                آخرین به‌روزرسانی:
                {" "} {toPersianNumber(moment(new Date()).format('jYYYY/jMM/jDD') + " - " + moment(new Date()).format('HH:mm'))
                }            </p>
            <p className={style.name}>ربات دیجی‌کالا موبیشا</p>
        </div>
    </div>
}

export default withRouter(Dashboard);